import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DirectiveModule } from '../../directives/directive.module';
import { PipeModule } from '../../pipe/pipe.module';
import { alertInsufficientPopupMobileComponent } from './mobile/alertInsufficientPopup.layout.mobile.component';

@NgModule({
  declarations: [alertInsufficientPopupMobileComponent],
  imports: [CommonModule, TranslateModule, DirectiveModule, PipeModule],
  exports: [alertInsufficientPopupMobileComponent],
})
export class alertInsufficientPopupModule {}
